import { FormInstance, Layout, MenuProps } from "antd";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/app/hooks";
import { selectUser } from "src/appRedux/reducers/userReducer";
import { checkVaiTroUserLogin } from "src/util/Commom";
import configUrl from "src/util/config";

import ContentAdmin from "./Content";
import HeaderAdmin from "./Header";
import SidebarAdmin from "./SiderBar";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "src/app/store";
import { fetchApi, selectData } from "src/appRedux/reducers/commonApiReducer";

const { Footer } = Layout;

interface NhomTaiLieu {
  id: number;
  tenNhomTuLieu: string;
}

export const AdminLayout = () => {
  const navigate = useNavigate();
  const useInfo = useAppSelector(selectUser);
  const { collapsed } = useAppSelector(
    (state: RootState) => state.commonData.dataSets || false
  );
  const isAdmin = checkVaiTroUserLogin(useInfo, "ADMIN");
  const [listVaiTro, setListVaiTro] = useState<any[]>([]);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [isCollapsed, setIsCollapsed] = useState(collapsed || false);
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const path = location.pathname.slice(1);
  const [pathName, setPathName] = useState(path);
  const paramHeader = pathName.split("/")[0];
  const formRef = useRef<FormInstance>(null);
  const dispatch = useAppDispatch();
  const listNhomTaiLieu = useAppSelector(selectData)
    .listNhomTaiLieu as NhomTaiLieu[];

  useEffect(() => {
    // Hàm cập nhật kích thước
    const handleResize = () => {
      setWindowSize(window.innerWidth);
      const newIsCollapsed = collapsed || (windowSize < 992 && !collapsed);
      setIsCollapsed(newIsCollapsed);
    };

    // Thêm event listener để theo dõi sự thay đổi kích thước
    window.addEventListener("resize", handleResize);

    // Cleanup: Gỡ bỏ event listener khi component bị gỡ bỏ
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const newIsCollapsed = collapsed || (windowSize < 992 && !collapsed);
    setIsCollapsed(newIsCollapsed);
  }, [collapsed, windowSize]);

  useEffect(() => {
    getDataNhomTaiLieu();
    const dataVaiTro = useInfo?.user?.vaiTros;
    const listVaiTroAll = dataVaiTro
      ? dataVaiTro.map((item: { item: any }) => item)
      : [];
    setListVaiTro(listVaiTroAll);
  }, [useInfo]);

  const getDataNhomTaiLieu = async (): Promise<void> => {
    const configAPI = {
      url: `api/nhomtulieus?keyword`,
      method: "GET",
      value: null,
      apiType: "LIST",
      params: {
        page: -1
      },
      getName: "listNhomTaiLieu"
    };
    await dispatch(fetchApi(configAPI));
  };

  const onClickCollapsed = () => {
    setIsCollapsed(!isCollapsed);
  };

  const onClickOpenDrawer = () => {
    setVisible(true);
  };

  const onClickCloseDrawer = () => {
    setVisible(false);
  };

  const onClickMenu: MenuProps["onClick"] = (e) => {
    navigate(`/${paramHeader}/${e.key}`);
    setVisible(false);
    if (formRef && formRef.current) {
      formRef.current.resetFields();
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SidebarAdmin
        isAdmin={isAdmin}
        listVaiTro={listVaiTro}
        isCollapsed={isCollapsed}
        onClickCollapsed={onClickCollapsed}
        windowSize={windowSize}
        visible={visible}
        onClickCloseDrawer={onClickCloseDrawer}
        onClickMenu={onClickMenu}
        menuSiderBar={listNhomTaiLieu}
        pathName={pathName}
      />
      <Layout>
        <HeaderAdmin
          isAdmin={isAdmin}
          listVaiTro={listVaiTro}
          isCollapsed={isCollapsed}
          onClickOpenDrawer={onClickOpenDrawer}
          windowSize={windowSize}
          setPathName={setPathName}
          menuSiderBar={listNhomTaiLieu}
        />
        <ContentAdmin formRef={formRef} />
        <Footer>{configUrl.footerText}</Footer>
      </Layout>
    </Layout>
  );
};
